import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import SydButton from '../../../../../../commonDesign/Button'
import EmptySection from '../../../../../../atoms/EmptySection'

function PresentationListSidebar ({
  presentationOptions,
  selectedOption,
  onSelectOption,
  onAddOption,
  onRemoveOption
}) {
  const optionEntries = Object.entries(presentationOptions || {})

  return (
    <div style={{
      borderRight: '1px solid var(--color-neutral-600)',
      paddingRight: '16px',
      minHeight: '400px'
    }}
    >
      <div style={{ marginBottom: '12px' }}>
        <SydButton
          variant='primary'
          size='sm'
          icon='add'
          onClick={onAddOption}
          style={{ width: '100%' }}
        >
          Add Presentation
        </SydButton>
      </div>

      {optionEntries.length === 0 ? (
        <div style={{ paddingTop: '32px' }}>
          <EmptySection
            title='No Presentations'
            description='Click Add Presentation to get started'
            emptyDescription
          />
        </div>
      ) : (
        <div>
          {optionEntries.map(([code, data]) => (
            <div
              key={code}
              onClick={() => onSelectOption(code)}
              style={{
                padding: '12px',
                marginBottom: '8px',
                borderRadius: '4px',
                cursor: 'pointer',
                color: selectedOption === code ? 'var(--color-contrast-primary-500)' : 'inherit',
                backgroundColor: selectedOption === code ? 'var(--color-primary-500)' : 'transparent',
                border: selectedOption === code ? '1px solid var(--color-primary-500)' : '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, marginBottom: '2px' }}>{data.displayName}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--color-neutral-400)' }}>
                  {data.type} • {code}
                </div>
              </div>
              <IconButton
                size='small'
                onClick={(e) => {
                  e.stopPropagation()
                  onRemoveOption(code)
                }}
              >
                <DeleteIcon fontSize='small' />
              </IconButton>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

PresentationListSidebar.propTypes = {
  presentationOptions: PropTypes.object.isRequired,
  selectedOption: PropTypes.string,
  onSelectOption: PropTypes.func.isRequired,
  onAddOption: PropTypes.func.isRequired,
  onRemoveOption: PropTypes.func.isRequired
}

export default PresentationListSidebar
